import { ErrorService } from 'src/services';
import { createReducer } from 'typesafe-actions';
import {
  addPhaseAsync,
  deletePhaseAsync,
  getPhasesAsync,
  setPhaseModalType,
  setPhases,
  setRefreshTable,
  setSelectedPhase,
  updatePhaseAsync,
} from './actions';
import { PhaseInfo, PhaseModalType } from './types';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */

export const INITIAL_PHASE: PhaseInfo = {
  code: '',
  description: '',
  status: '',
};

export type IPhasesState = Readonly<{
  phases: Array<PhaseInfo>;
  totalPhases: number;
  isLoading: boolean;
  openModalType: PhaseModalType;
  selectedPhase: PhaseInfo;
  isRefresh: boolean;
}>;

const initialState: IPhasesState = {
  phases: [],
  totalPhases: 0,
  isLoading: false,
  openModalType: null,
  selectedPhase: INITIAL_PHASE,
  isRefresh: false,
};

/* ------------- Selectors ------------- */

export default createReducer(initialState)
  /* ------------- phasesAsync ------------- */
  .handleAction(getPhasesAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(getPhasesAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    phases: action.payload.phaseCodes as PhaseInfo[],
    totalPhases: action.payload.total,
    isRefresh: false,
    error: null,
  }))
  .handleAction(getPhasesAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))

  /* ------------- phaseUpdateAsync ------------- */
  .handleAction(updatePhaseAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(updatePhaseAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openModalType: false,
    selectedPhase: INITIAL_PHASE,
    isRefresh: true,
    error: null,
  }))
  .handleAction(updatePhaseAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- phasesAddAsync ------------- */

  .handleAction(addPhaseAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(addPhaseAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openModalType: false,
    selectedPhase: INITIAL_PHASE,
    isRefresh: true,
    error: null,
  }))
  .handleAction(addPhaseAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- phaseDeleteAsync ------------- */
  .handleAction(deletePhaseAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(deletePhaseAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    isRefresh: true,
    openModalType: false,
    selectedJob: INITIAL_PHASE,
    error: null,
  }))
  .handleAction(deletePhaseAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- setPhases ------------- */
  .handleAction(setPhases, (state, action) => ({
    ...state,
    phases: action.payload,
  }))
  .handleAction(setPhaseModalType, (state, action) => ({
    ...state,
    openModalType: action.payload,
  }))
  .handleAction(setSelectedPhase, (state, action) => ({
    ...state,
    selectedPhase: action.payload,
  }))
  .handleAction(setRefreshTable, (state, action) => ({
    ...state,
    isRefresh: action.payload,
  }));
